if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.error = false;

              fetch(`${routes.cart_url}.js`)
                .then((response) => response.json())
                .then((cartData) => {
                  const bubble = document.querySelector('.cart-count-bubble');

                  if (cartData.item_count > 0) {
                    let countBubble = bubble;

                    if (!countBubble) {
                      const cartLink = document.querySelector('#cart-icon-bubble');

                      if (cartLink) {
                        countBubble = document.createElement('div');
                        countBubble.className = 'cart-count-bubble';
                        cartLink.appendChild(countBubble);
                      }
                    }

                    if (countBubble) {
                      countBubble.innerHTML = `
                        <span aria-hidden="true">${cartData.item_count < 100 ? cartData.item_count : ''}</span>
                        <span class="visually-hidden">${cartData.item_count}</span>
                      `;
                    }
                  } else if (bubble) {
                    bubble.remove();
                  }

                  // Vytvoření vyskakovacího okna
                  let modal = document.getElementById('custom-cart-modal');

                  if (!modal) {
                    modal = document.createElement('div');
                    modal.id = 'custom-cart-modal';

                    modal.innerHTML = `
                      <div class="custom-cart-overlay"></div>
                      <div class="custom-cart-dialog" role="dialog"
                          aria-modal="true" aria-labelledby="custom-cart-title">
                        <button type="button" class="custom-cart-close"
                                aria-label="Zavřít">&times;</button>
                        <div class="custom-cart-check">&#10003;</div>
                        <h2 id="custom-cart-title">Produkt přidán do košíku</h2>
                        <p class="custom-cart-description">
                          Produkt byl úspěšně přidán do vašeho košíku.
                        </p>
                        <div class="custom-cart-actions">
                          <button type="button" class="custom-cart-continue">
                            Pokračovat v nákupu
                          </button>
                          <a href="${routes.cart_url}" class="custom-cart-checkout">
                            Přejít do košíku
                          </a>
                        </div>
                      </div>
                    `;

                    const style = document.createElement('style');
                    style.id = 'custom-cart-modal-style';
                    style.textContent = `
                      #custom-cart-modal {
                        position: fixed;
                        inset: 0;
                        z-index: 99999;
                        display: none;
                        align-items: center;
                        justify-content: center;
                        padding: 20px;
                        font-family: inherit;
                      }
                      #custom-cart-modal.is-open { display: flex; }
                      .custom-cart-overlay {
                        position: absolute;
                        inset: 0;
                        background: rgba(0,0,0,.5);
                      }
                      .custom-cart-dialog {
                        position: relative;
                        width: 100%;
                        max-width: 430px;
                        padding: 36px 28px 28px;
                        background: #fff;
                        color: #222;
                        text-align: center;
                        border-radius: 12px;
                        box-shadow: 0 10px 40px rgba(0,0,0,.2);
                        animation: customCartAppear .2s ease-out;
                      }
                      .custom-cart-close {
                        position: absolute;
                        top: 10px;
                        right: 14px;
                        border: 0;
                        background: transparent;
                        font-size: 30px;
                        line-height: 1;
                        cursor: pointer;
                        color: #333;
                      }
                      .custom-cart-check {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 48px;
                        height: 48px;
                        margin: 0 auto 16px;
                        border-radius: 50%;
                        background: #e6f5e9;
                        color: #218342;
                        font-size: 26px;
                      }
                      #custom-cart-title {
                        margin: 0 0 10px;
                        font-size: 23px;
                        line-height: 1.3;
                      }
                      .custom-cart-description {
                        margin: 0 0 24px;
                        font-size: 15px;
                        line-height: 1.5;
                      }
                      .custom-cart-actions {
                        display: grid;
                        gap: 10px;
                      }
                      .custom-cart-continue,
                      .custom-cart-checkout {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        min-height: 48px;
                        padding: 12px 16px;
                        border-radius: 5px;
                        font: inherit;
                        font-size: 15px;
                        font-weight: 600;
                        text-decoration: none;
                        cursor: pointer;
                        box-sizing: border-box;
                      }
                      .custom-cart-continue {
                        background: #fff;
                        color: #222;
                        border: 1px solid #222;
                      }
                      .custom-cart-checkout {
                        background: #222;
                        color: #fff;
                        border: 1px solid #222;
                      }
                      @keyframes customCartAppear {
                        from { opacity: 0; transform: translateY(8px); }
                        to { opacity: 1; transform: translateY(0); }
                      }
                      @media (prefers-reduced-motion: reduce) {
                        .custom-cart-dialog { animation: none; }
                      }
                    `;

                    document.head.appendChild(style);
                    document.body.appendChild(modal);

                    const closeModal = () => {
                      modal.classList.remove('is-open');
                      document.body.style.overflow = '';
                    };

                    modal.querySelector('.custom-cart-close')
                      .addEventListener('click', closeModal);

                    modal.querySelector('.custom-cart-continue')
                      .addEventListener('click', closeModal);

                    modal.querySelector('.custom-cart-overlay')
                      .addEventListener('click', closeModal);

                    modal.addEventListener('keydown', (event) => {
                      if (event.key === 'Escape') closeModal();
                    });
                  }

                  modal.classList.add('is-open');
                  document.body.style.overflow = 'hidden';
                  modal.querySelector('.custom-cart-close').focus();
                })
                .catch((error) => console.error(error));

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
              });

              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
